export const errorMessages = {
    // Authentication
    NotAuthorisedAccountInactive: 'Niet geautoriseerd, account is niet actief',
    InvalidToken: 'Token is ongeldig',
    LoginRequired: 'Je moet ingelogd zijn om hier toegang toe te hebben',
    AccessDenied: 'Toegang geweigerd',
    NoAccessibleOrganizations: 'Je bent niet gekoppeld aan een organisatie, hierom wordt de toegang geweigerd',

    // General errors
    NetworkError: 'Kan geen verbinding maken met de server.',

    // Requirements
    NameRequired: 'Naam is verplicht',
    TeamRequired: 'Team is verplicht',
    OrganizationRequired: 'Organisatie is verplicht',
    ModuleRequired: 'Module is verplicht',
    OrganizationNameRequired: 'Organisatienaam is verplicht',

    // Validation
    EmailInvalid: 'Geen geldig e-mailadres ingevuld',
    ColumnNameRequired: 'Kolomnaam {columnName} is verplicht',

    // NotFound
    OrganizationNotFound: 'Organisatie niet gevonden',
    EmployeeNotFound: 'Medewerker niet gevonden',
    SourceNotFound: 'Bron niet gevonden',
    ActionPointNotFound: 'Actiepunt niet gevonden',

    // Failed creation
    EmployeeCreationFailed: 'Medewerker kon niet worden aangemaakt',
    NoteCreationFailed: 'Notitie kon niet worden aangemaakt',
    TeamCreationFailed: 'Team kon niet worden aangemaakt',
    ActionPointCreationFailed: 'Actiepunt kon niet worden aangemaakt',

    // Failed update
    EmployeeUpdateFailed: 'Medewerker kon niet worden bijgewerkt',
    ActionpointUpdateFailed: 'Actiepunt kon niet worden bijgewerkt',
    OrganizationUpdateFailed: 'Organisatie kon niet worden bijgewerkt',
    TeamUpdateFailed: 'Team kon niet worden bijgewerkt',
    EmailUpdateFailed: 'E-mailadres kon niet worden gewijzigd',
    PasswordUpdateFailed: 'Wachtwoord kon niet worden gewijzigd',
    EmployeeFailedLink: 'Medewerker kon niet worden gekoppeld',
    FailedToSetCurrentOrganization: 'Kon organisatie niet instellen als huidige organisatie',

    // Already exists
    SourceAlreadyExists: 'Bron bestaat al',

    // Failed deletion
    EmployeeRemovalFailed: 'Medewerker kon niet worden verwijderd',

    // Failed fetch
    PrioritiesFetchFailed: 'Prioriteiten konden niet worden opgehaald',
    EmployeesFetchFailed: 'Medewerkers konden niet worden opgehaald',
    EmployeeTeamsFetchFailed: 'Teams van medewerker konden niet worden opgehaald',
    EmployeeLoadFailed: 'Kon de gegevens van de medewerker niet laden',
    FailedToUpdateEmployeeList: 'Kon lijst niet bijwerken met de gewijzigde medewerker, ververst de pagina opnieuw om de wijzigingen te zien',

    // Failed save
    SourceSaveFailed: 'Bron kon niet worden opgeslagen',

    // Files
    FileCantLoad: 'Bestand kan niet worden geladen',
    FilesCantLoad: 'Bestanden konden niet worden geladen',
    FileCantProcess: 'Bestand kan niet worden verwerkt',
    FileCantRead: 'Bestand kan niet worden gelezen',
    FileCantDownload: 'Bestand kon niet worden gedownload',
    FileCantExtractContent: 'Bestandsinhoud kon niet geretourneerd worden',
    DirectoryCantLoad: 'Mapinhoud kon niet geladen worden',

    // Error pages
    Error403: 'Je hebt geen toegang tot deze pagina',
    Error404: 'De pagina die je zoekt bestaat niet.',
    ErrorOther: 'Er is een fout opgetreden.',

    // Error pages (short)
    ErrorShort403: 'Geen toegang',
    ErrorShort404: 'Pagina niet gevonden',
    ErrorShortOther: 'Fout opgetreden',

    LinkProblem: 'Er is een probleem met de link'
};
